import styled, { css } from 'styled-components';

import {
    Flex,
    mediaMixin,
    spaceMixin,
    token,
} from '@zillow/constellation';
import { HR } from '@zillow/zrs-comet';

export const StyledContainer = styled(Flex)`
    background-color: ${token('colors.white')};
    flex: 1;

    ${mediaMixin('xxl', css`
        max-width: 1280px;
        border-radius: 3px;
    `)};
`;

export const StyledHR = styled(HR)`
    width: 142px;
`;
